/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LeaveAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Tools/LeaveAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let authAccessTokenDataUserIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.user_id',
})
let threadResourcesValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'resources',
})
let aggregateData = fromHelpers.isMember(authAccessTokenDataUserIdValueData, threadResourcesValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}